import { IconButton, CircularProgress } from '@mui/material';
import ArticleIcon from '@mui/icons-material/Article';
import VerifiedIcon from '@mui/icons-material/Verified';
import YouTubeIcon from '@mui/icons-material/YouTube';
import Fade from '@mui/material/Fade';
import * as theme from '../../../theme';

export default function TrainingContentItem({ children, ...props }) {
  const getIcon = () => {
    if (props.icon) {
      if (props.icon === 'report') {
        return <ArticleIcon sx={{ flex: '0 0 auto', color: props.isComplete ? theme.Colors.GoldDark : theme.Colors.Purple }} />;
      } else if (props.icon === 'video') {
        return <YouTubeIcon sx={{ flex: '0 0 auto', color: props.isComplete ? theme.Colors.GoldDark : theme.Colors.Purple }} />;
      } else if (props.icon === 'multi') {
        return <ArticleIcon sx={{ flex: '0 0 auto', color: props.isComplete ? theme.Colors.GoldDark : theme.Colors.Purple }} />;
      }
    }
  };

  return (
    <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
      <div className={props.disabled ? 'cardLinkDisabled' : props.actionLink ? 'cardLink' : 'cardLinkNoClick' } style={{ color: props.isComplete ? theme.Colors.GoldDark : theme.Colors.Purple, display: 'flex', flex: 3, width: '100%', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }} onClick={() => props.actionLink != null ? props.actionLink() : null}>
        <div style={{ ...theme.Container.flexRowFixed, padding: 8 }}>
          {getIcon()}
          <div style={{ flex: 1, fontSize: 14, fontWeight: 500 }}>
            {props.label}
            <br />
            <Fade in={true} timeout={300}>
              <span style={{ fontWeight: 'normal', fontSize: '0.85em', color: theme.Colors.GrayMedium }}>
                {props.content ? props.content : <br/>}
              </span>
            </Fade>
          </div>
        </div>
      </div>
      {props.canComplete && (
        <div style={{ display: 'flex', flex: 0.5, justifyContent: 'right', width: '100%' }}>
          {!props.isComplete ? (
            <Fade in={true} timeout={300}>
              <IconButton
                aria-label="complete"
                color="secondary"
                onClick={() => props.onComplete(props.action)}
              >
                {props.action === 'scanPaid' && props.processing || props.action === 'cancelled' && props.processing ? (
                  <CircularProgress size={24} color="secondary" />
                ) : (
                  <VerifiedIcon sx={{ fontSize: 24 }} />
                )}
              </IconButton>
            </Fade>
          ) : !props.disabled && props.isComplete ? (
            <IconButton
              aria-label="complete"
              color="primary"
              disabled
            >
              <VerifiedIcon sx={{ fontSize: 24 }} color="primary" />
            </IconButton>
          ) : (props.disabled && !props.nextUp) || !props.isComplete ? (
            <IconButton
              aria-label="complete"
              color="secondary"
              disabled
            >
              <VerifiedIcon sx={{ fontSize: 24 }} />
            </IconButton>
          ) : null}
        </div>
      )}
    </div>
  );
}